import React from 'react'
import { connect } from 'react-redux'
import Heading from '../../../core/components/typography/heading/Heading'
import {ExitableNavBar} from '../../../core/components/navbar/index'
import { getGMProblem, viewExplanations,changeViewing } from '../../../redux/modules/grandmaster'
// import {showModal} from '../../../redux/modules/modal'
import {toJS} from '../../../util/ToJS'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {makeSelectTopic} from '../../../redux/modules/topic'
// import VisibleGrandmasterProgress from './VisibleGrandmasterProgress'
import Box from '../../../core/components/box/Box'
import {UniLink} from '../../../core/components/unilink/index'
// import {PrimaryButton} from '../../../core/components/unilink/index'


const mapDispatchToProps = dispatch => {
  return {
    getGMProblem: (topicId, problemId=0) => {
      dispatch(getGMProblem(topicId,problemId))
    },
    exitExplanations: () => {
      dispatch(viewExplanations(false))
    },
    showScoreScreen: (subjectId) => {
      dispatch(changeViewing('scores'))
    }
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const mapStateToProps = state => {
    const topic = selectTopic(state)
    const shouldShowScoreScreen = state.getIn(['grandmaster','problemsInSession']).size > 0
    return {
      breadcrumbTopics: topic.get('breadcrumbs'),
      topicTitle: topic.get('renderedTitle'),
      topicId: topic.get('id'),
      topicSlug: topic.get('slug'),
      isViewingExplanations: state.getIn(['grandmaster','isViewingExplanations']),
      viewing: state.getIn(['grandmaster','viewing']),
      shouldShowScoreScreen
    }
  }
  return mapStateToProps
}

export default function withExitableNavGM(Component) {
  return connect(makeMapStateToProps, mapDispatchToProps)(toJS(props => {
    const topicTitle = props.topicTitle
    // let topicId = props.topicId
    let navbarSubject = props.topicId
    if (props.breadcrumbTopics && props.breadcrumbTopics.length) {
      navbarSubject = props.breadcrumbTopics[0].id
    }
    let goBack = props.shouldShowScoreScreen ? () => props.showScoreScreen(navbarSubject) : () => props.history.push(props.topicSlug)
    const {isViewingExplanations, exitExplanations, viewing} = props
    let backButton = null
    let centerComponent = () => (
      <Box display='flex' justifyContent='center' width='100%'>
        <Box minWidth='2rem' smDisplay='none' display='block' />
        <Box maxWidth='60rem' width='100%' display='flex' justifyContent='center' paddingX={3}>
          <Heading
            size='lg'
            fontWeight='bold'
            color='white'
            truncate
            dangerouslySetInnerHTML={{__html: topicTitle}} />
        </Box>
      </Box>
    )
    if (isViewingExplanations) {
      backButton = () => (
        <UniLink className='grandmaster-explanations__back'
          onClick={exitExplanations}>
          <FontAwesomeIcon icon={['fa', 'arrow-left']} />
        </UniLink>
      )
    } else if (viewing === 'scores') {
      backButton = () => (
        <div />
      )
    }
    const embeddedComponents = {LeftComponent: backButton, CenterComponent: centerComponent}
    return (
      <div className="with-nav">
        <ExitableNavBar
          navbarSubject={navbarSubject}
          embeddedComponents={embeddedComponents}
          goBack={goBack} />
        <Component {...props} className='component' />
      </div>
    )
  }))
}



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/WithExitableNavGM.js